<template>
    <div>
    <section id="page-title">
      <div class="bg-header"></div>
      <div class="container clearfix">
        <span>{{empresa}}</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link :to="'/areacliente'" class="button button-mini button-circle " tag="a">Painel</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="'/areacliente/cadastro'" class="button button-mini button-circle" tag="a">Cadastro</router-link>
          </li>
          <li class="breadcrumb-item">
            <a @click="fnSair()" class="button button-mini button-circle button-red"><i class="icon-off"></i>Sair</a>
          </li>
        </ol>
      </div>
    </section>
    </div>
</template>

<script>
  import { clientKey } from "../global/utils";

    export default {
        name: "Cabecalho",
        data() {
          return {
            empresa:'',
          }
        },
        mounted() {
          this.configCabecalho();
          this.validateToken();
        },
        methods: {
          async validateToken(){
            this.validationToken = true
            const userData = localStorage.getItem(clientKey)
            if(!userData)
            {
                this.$store.commit('setClient',null)
                this.validationToken = false
                this.$router.push({name: "auth"})
                return
            }
            const res = await this.$http.post('clientes/validate',userData)
            if(res.data){
                this.$store.commit('setClient', localStorage.getItem(clientKey))
                localStorage.setItem(clientKey,userData)
                this.idUsuario = userData.userId
            }else{
              localStorage.removeItem(clientKey)
              this.$router.push({name: "auth"})
            }
            this.validationToken = false
          },         
          convertToken(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
        
            return JSON.parse(jsonPayload);
          },
          configCabecalho(){
              var token = localStorage.getItem(clientKey)
              var dataToken = this.convertToken(token)
              this.empresa =dataToken.unique_name
          },
          fnSair(){
            this.$store.commit("setClient",'')
            window.location.href = "/areacliente/auth"
          }
        },
    }
</script>

<style lang="scss" scoped>
    #page-title{
        margin-bottom: 45px;
        padding-top: 0 !important;
        padding-bottom: 15px;
    }
    .bg-header{
              background-image: url("/img/cabecalho_autoespecialistas.jpeg");
        background-size: 100%;
        height: 130px;;
    }
    a{
      cursor:pointer;
      color: #fff;
    }
    .breadcrumb-item::before{
      content: none !important;
    }
</style>